import { useState } from "react";
import styles from "./ItemBox.module.css";
import { Box, Uniter } from "../../../../helbest";
import { Comma } from "../../../../base/utils";
import ShareModal from "../ShareModal/ShareModal";

import { ReactComponent as ShareIcon } from "../../../../assets/svg/share.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as OutOfStock } from "../../../../assets/svg/out-of-stock.svg";
import { Button } from "antd";
import { LangLink } from "../../LangLink/LangLink";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { channelDetails } from "../../../../base/env";

const url = window.location.origin;

const ItemBox = ({ data, add_to_cart, addLoading }) => {
  const [share_modal_open, set_share_modal_open] = useState(false);
  const { t, i18n } = useTranslation();
  const { lang } = useParams();

  const { Login: { channel } } = useSelector((state) => state);
  const precision = channelDetails[channel].precision;
  const savingAmount = (data.price - data.payable_amount).toFixed(precision);
  const currency = channelDetails[channel].currency;

  return (
    <Box id={data.tag} className="component-product-item">
      <LangLink to={`/product/${data.id}`}>
        <div className="product-item-body">
          <div className="product-item-data">
            <span className="product-item-data-title">
              {i18n.language === "ar" && data.translation
                ? data.translation
                : data.name}
            </span>

            <div className={styles.PriceDiscountContainer}>
              <div className="product-item-data-price-container">
                <div className="product-item-data-prices">
                  {data.payable_amount !== data.price && (
                    <Uniter className={styles.RealPrice} childSize={16} unitColor={'#858585'}>
                      {data.price}
                    </Uniter>
                  )}
                  <Uniter isBold childSize={16}>
                    {data.payable_amount}
                  </Uniter>
                </div>
              </div>

              {savingAmount > 0 && (
                <div className={styles.Discount}>
                  <span>{t("common.saving")}</span>
                  <Uniter className={styles.UnitColor} isBold >{Comma(savingAmount)}</Uniter>
                </div>
              )}
            </div>

            {/* <div className={styles.Stock}>
              {data.quantityAvailable === 0 ? (
                <span>{t("cart.out_of_stock")}</span>
              ) : (
                <>
                  <span>{t("cart.stock_available")}</span>
                  <span> {data.quantityAvailable}</span>
                </>
              )}
            </div> */}

          </div>

          <div className="product-item-img">
            <img loading="lazy" src={data.image} alt={data.name} />
            {data.quantityAvailable === 0 && (
              <OutOfStock className="out-of-stock" />
            )}
          </div>
        </div>
      </LangLink>
      <div className="product-item-footer ws-100">
        <div className={styles.Buttons}>
          <Button
            onClick={() => add_to_cart(data)}
            loading={addLoading}
            disabled={data.quantityAvailable === 0}
            type="primary"
            size="middle"
          >
            {t("home.detail.add")}
          </Button>
          <LangLink to={`/product/${data.id}`}>
            <Button variant="outlined" color="primary" size="middle">
              {t("cart.more_details")}
            </Button>
          </LangLink>
        </div>
        <ShareIcon
          className={styles.ShareIcon}
          onClick={() => set_share_modal_open(true)}
        />
        <ShareModal
          shareModal={share_modal_open}
          setShareModal={set_share_modal_open}
          value={`${url}/${lang}/product/${data.id}`}
        />
      </div>
    </Box>
  );
};

export default ItemBox;